import { PropertyHelper } from '@/helpers/property.helper';
import { UserHelper } from '@/helpers/user.helper';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { RealProperty, User, UsersService } from '@eemo/api-client';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';

export class CertificationPrintDialogData {
  prop: RealProperty;
}

@Component({
    selector: 'app-certification-print-dialog',
    templateUrl: './certification-print-dialog.component.html',
    styleUrls: ['./certification-print-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, NgIf, MatIconModule, MatButtonModule]
})
export class CertificationPrintDialogComponent implements OnInit {
  owner: User;
  ownerAddressExists = false;
  UserHelper = UserHelper;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CertificationPrintDialogData,
    public dialogRef: MatDialogRef<CertificationPrintDialogComponent>,
    public propertyHelper: PropertyHelper,
    public userHelper: UserHelper,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    this.usersService.getUser(this.data.prop.owner.uid).subscribe((user) => {
      this.owner = user;
      this.ownerAddressExists = this.owner.address !== undefined;
    });
  }

  close(): void {
    this.dialogRef.close(true);
  }
}
